import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { PATHS } from "../../layout/path/Path";

export default function HomePage() {
  const navigate = useNavigate();
  useEffect(() => {
    navigate(PATHS.BITEL_SUBASTA);
  }, []);
  return null;
}
